import conf from './config'
import _ from 'lodash'

const mqtt = require('mqtt')

export class MqttClient {
    constructor() {
        this._username = '';
        this._password = '';
        this._topics = [];
        this._listeners = {};
    }

    connect(username, password, onConnect){
        this._username = username;
        this._password = password;

        // console.log(`mqtt connecting to ${conf.mqtt.host} ${conf.mqtt.port} ${username} ${password}`);

        let host = process.env.MIX_MQTT_HOST;
        let wsConnType = process.env.MIX_MQTT_WSS ? 'wss' : 'ws';
        if (host === 'same') host = window.location.host;
        // this.client  = mqtt.connect(`ws://${host}:${process.env.MIX_MQTT_PORT}/mqtt`,{
        this.client  = mqtt.connect(`${wsConnType}://${host}/mqtt`,{
            // host: conf.mqtt.host,
            // port: conf.mqtt.port,
            username: this._username,
            password: this._password,
            clientId: this._username+'_'+Math.round(Math.random()*1000000),
        })

        this.client.on('connect', ()=>{
            if(onConnect){
                onConnect(true)
            }
            console.log('mqtt connected');
            if(this._topics.length){
                this._topics.forEach((t)=>{
                    this.client.subscribe(t, function (err) {
                        if (err) console.error(err);
                    })
                })
            }
        })

        this.client.on('close', ()=>{
            console.log('mqtt disconnected');
            if(onConnect){
                onConnect(false)
            }
        })

        this.client.on('message', (topic, message) => {
            _.forEach(this._listeners, (listener, id)=>{
                if(!listener.topic.test(topic)) return;
                message =  message.toString()
                if(listener.params && listener.params.json){
                    message = JSON.parse(message)
                }
                listener.onMessage(listener.topic.exec(topic), message);
                if(listener.params && listener.params.once){
                   delete this._listeners[id]
                    // console.log(this._listeners);
                }
            })
        })
    }

    subscribe(topic){
        this._topics.push(topic);
        this._topics = _.uniq(this._topics);
        this.client.subscribe(topic);
    }
    unsubscribe(topic){
        this._topics = _.remove(this._topics, t => t !== topic);
        this.client.unsubscribe(topic);
    }

    publish(topic, msg){
        this.client.publish(topic, msg)
    }

    /**
     *
     * @param id
     * @param topicRegex
     * @param callback function Принимает 2 параметра - сообщение и топик
     * @param params object {
     * json: true | false,
     * once: true | false - то, что должно отработать только 1 раз. Далее этот listener самоудаляется
     * }
     */
    addListener(id, topicRegex, callback, params){
        this._listeners[id] = {
            topic: new RegExp(topicRegex),
            onMessage: callback,
            params,
        }
    }

    removeListener(id){
        delete this._listeners[id];
    }
}
